"use client";

import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurStory() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    rootMargin: "0px 0px -100px 0px"
  });
  return <section data-section-id="72501" id="about-lo-studio" className="dark bg-background text-foreground w-full relative flex flex-col">
      
      <div className="relative w-full h-[70vh] md:h-[85vh] overflow-hidden border-b border-primary/20">
        <img src="https://studiodclegal.it/wp-content/uploads/2026/04/Gemini_Generated_Image_kbhleckbhleckbhl.png" alt="Lo Studio - Eccellenza e Rigore Professionale" className="w-full h-full object-cover object-top grayscale" />
        
        <div className="absolute inset-0 bg-gradient-to-b from-background/5 via-background/30 to-background" />
      </div>

      
      <div className="w-full px-6 py-20 md:py-32 relative z-10 -mt-32 md:-mt-48">
        <div ref={textRef} className={`max-w-[700px] mx-auto flex flex-col gap-8 transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <h2 className="font-light tracking-tight text-foreground mb-4 !text-7xl !font-sans">Lo Studio</h2>

          <div className="space-y-8 text-lg md:text-xl leading-relaxed text-muted-foreground font-sans">
    <p className="!text-justify">
  Lo Studio DCLegal, fondato dall’Avv. Giacomo Cardani dopo quasi vent’anni di esperienza come Legal &amp; Corporate Counsel in realtà italiane e multinazionali, offre <strong>assistenza legale specializzata</strong> in compliance, contrattualistica e corporate governance, con competenze consolidate anche in diritto penale d’impresa e diritto tributario. 
  <br /><br />
  Lo Studio supporta società ed enti nella predisposizione di Modelli 231, nella redazione e revisione dei contratti, nell’implementazione di modelli privacy by design e nella gestione dei sistemi di intelligenza artificiale, con particolare attenzione ai profili di governance e conformità normativa. I professionisti di DCLegal ricoprono incarichi di Presidente o componente di Organismi di Vigilanza e svolgono attività di Data Protection Officer (DPO), garantendo un supporto continuativo orientato alla prevenzione dei rischi e alla corretta gestione dei processi aziendali. DCLegal collabora stabilmente con Development Compliance Partners S.r.l., offrendo così un’assistenza integrata che comprende audit, verifiche tecnico-specialistiche (tra cui cybersecurity, NIS2 e DORA), supporto in materia di Salute e Sicurezza, Ambiente e Sicurezza Alimentare, oltre all’accompagnamento nei percorsi di certificazione ISO. 
  <br /><br />
  L’obiettivo dello Studio è affiancare imprese, management e professionisti con un <strong>approccio multidisciplinare</strong>, offrendo soluzioni giuridiche concrete e strumenti efficaci per affrontare un contesto normativo in continua evoluzione.
          </p>
        
            
          </div>

          <div className="pt-12 flex flex-col sm:flex-row items-start gap-6">
            <Button asChild size="lg" className="font-sans tracking-wide rounded-none px-8 bg-primary text-primary-foreground hover:bg-primary/90">
              
            </Button>
            <div className="flex flex-col justify-center h-full">
              <span className="text-sm text-muted-foreground uppercase tracking-widest font-mono">Milano — Fondato nel 2010</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}